import { Form } from "../../components/formik";
import { useDisclosure } from "./Disclosure.use";

export const Disclosure = () => {
    const { formProps } = useDisclosure();
    return <div>
            <Form {...formProps} />
        </div>
}